import { tracked } from '@glimmer/tracking';

import type { GeneralComponentClass } from 'webapp-types';

import InfolayerTypeDatasetSyncComponent from 'webapp/components/infolayer/type-dataset-sync';

import type {
	ConstructorData as BaseConstructorData,
	onCloseFn,
} from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemBase, {
	EXPIRE_ERROR,
	EXPIRE_PROGRESS,
} from 'webapp/models-custom/infolayer-item/base';
import { Type as GeneralType } from 'webapp/models-custom/infolayer-item/general';

export interface DatasetSyncType {
	title?: string;
	description?: string;
	avatar?: string;
	spaceAccessId: number;
	isError?: boolean;
	errorText?: string;
}

export interface ConstructorData extends BaseConstructorData {
	datasetSync: DatasetSyncType;
}

export default class InfolayerItemDatasetSync extends InfolayerItemBase {
	componentClass: GeneralComponentClass = InfolayerTypeDatasetSyncComponent;

	@tracked status = GeneralType.LOADING;
	@tracked datasetSync: DatasetSyncType;
	@tracked errorText = '';

	constructor(data: ConstructorData, onClose: onCloseFn) {
		super(data, onClose);

		this.datasetSync = data.datasetSync;
	}

	override get classes(): string {
		return super.classes + ' ' + this.status;
	}

	get isLoading() {
		return this.status === GeneralType.LOADING;
	}

	get isError() {
		return this.status === GeneralType.ERROR;
	}

	setError(errorText = '') {
		this.status = GeneralType.ERROR;
		this.errorText = errorText || 'Unknown error';
		this.expire(EXPIRE_ERROR);
	}

	setDone(sentDatasetSync: DatasetSyncType) {
		this.status = GeneralType.OK;
		this.datasetSync = sentDatasetSync;
		this.expire(EXPIRE_PROGRESS);
	}

	checkIfDuplicated(items: InfolayerItemBase[]): boolean {
		return items.some(
			(item) =>
				item instanceof InfolayerItemDatasetSync &&
				item.errorText === this.errorText &&
				this.isError,
		);
	}
}
